import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import qestIds from '../../../QestIds';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Preparation.LayerThickness`]: { uom: 'mm', format: { nearest: 0 } },
      [`${prefix}.Preparation.BulkDensityCorrectionSlope`]: { format: { nearest: 0.001 } },
      [`${prefix}.Preparation.BulkDensityCorrectionIntercept`]: { uom: 'Mg/m³', format: { nearest: 0.001 } },
      [`${prefix}.TheoreticalMaximumDensity.MaximumLabDensity`]: { uom: 'Mg/m³', format: { nearest: 0.001 } },
      [`${prefix}.Retest.OriginalTest.ImportedTest.Results.RelativeCompaction`]: { format: { nearest: 0.1 } },
      [`${prefix}.Retest.OriginalTest.ImportedTest.Results.AirVoids`]: { format: { nearest: 0.1 } },
      [`${prefix}.Measurements.ProbeDepth`]: { uom: 'mm', format: { nearest: 0 } },
      [`${prefix}.Measurements.AverageCorrectedBulkDensity`]: { uom: 'Mg/m³', format: { nearest: 0.001 } },
      [`${prefix}.Measurements.Readings.BulkDensity`]: { uom: 'kg/m³', format: { nearest: 0 } },
      [`${prefix}.Measurements.Readings.CorrectedBulkDensity`]: { uom: 'Mg/m³', format: { nearest: 0.001 } },

      [`${prefix}.Results.BulkDensity`]: { uom: 'Mg/m³', format: { nearest: 0.001 } },
      [`${prefix}.Results.TheoreticalMaximumDensity`]: { uom: 'Mg/m³', format: { nearest: 0.001 } },
      [`${prefix}.Results.RelativeCompaction`]: { format: { nearest: 0.1 } },
      [`${prefix}.Results.AirVoids`]: { format: { nearest: 0.1 } },
    },
    getLabelConfig(prefix)
  );

export default {
  [qestIds.asphaltNuclearFieldDensity.InHouseMethod]: getConfig,
};
